/**
 * EN content for the "Cannes – Gourdon" private excursion.
 *
 * Role: English translation of slugs/cannes-gourdon.ts, typed `ExcursionPage`
 * for the shared ExcursionSlugView. Dependencies: slug-excursions (type), image.
 * Slug mirrors FR (proper-noun place names → "cannes-gourdon").
 */
import type { ExcursionPage } from "../slug-excursions";
import gourdon from "@/assets/images/excursions/destinations/cannes.webp";

const page: ExcursionPage = {
  slug: "cannes-gourdon",
  hero: {
    title: "Cannes – Gourdon Excursion",
    subtitle:
      "From the beaches of Cannes to the hilltop village of Gourdon, a spectacular contrast.",
    ctaPrimaryHref: "/en/reservation",
    ctaPrimaryLabel: "Book now",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Get a quote",
    image: gourdon,
  },
  highlights: {
    title: "Highlights",
    items: [
      { text: "Cannes: the Croisette, Le Suquet, private beaches (view)" },
      { text: "Gourdon: a hilltop village with an exceptional panorama" },
      { text: "Craftspeople, confectionery, perfumes and local produce" },
      { text: "Scenic road through the Riviera back country" },
    ],
  },
  itinerary: {
    title: "Sample itinerary",
    steps: [
      {
        title: "Cannes",
        description: "Departure and a quick tour to your liking.",
      },
      {
        title: "Drive into the back country",
        description: "Viewpoints and photo stops.",
      },
      {
        title: "Gourdon",
        description: "Explore the village, free time.",
      },
    ],
  },
  practical: {
    title: "Practical information",
    items: [
      { label: "Duration", value: "4 to 6 hours" },
      { label: "Departure", value: "Cannes" },
      { label: "Tip", value: "Comfortable shoes (cobbled lanes)" },
      {
        label: "Option",
        value: "Perfumery / confectionery stop on request",
      },
    ],
  },
  seo: {
    title: "Cannes – Gourdon Excursion | Private Chauffeur Day Trip",
    description:
      "Private excursion from the beaches of Cannes to the hilltop village of Gourdon: panorama, craftspeople, perfumes and a scenic Riviera back-country road.",
    canonical: "/en/excursions/cannes-gourdon",
  },
};

export default page;
